import { render, staticRenderFns } from "./selectStuDialog.vue?vue&type=template&id=7c5a2d40&scoped=true"
import script from "./selectStuDialog.vue?vue&type=script&lang=js"
export * from "./selectStuDialog.vue?vue&type=script&lang=js"
import style0 from "./selectStuDialog.vue?vue&type=style&index=0&id=7c5a2d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a2d40",
  null
  
)

export default component.exports